import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { MediaQueryStylesContext } from '../context/MediaQueryStylesContext';
import MediaQueryStyles from './MediaQueryStyles';
export default function MediaQueryStylesProvider({
  children
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MediaQueryStyles, {}), /*#__PURE__*/_jsx(MediaQueryStylesContext.Provider, {
      value: {
        hasInjectedGlobalStyles: true
      },
      children: children
    })]
  });
}